import "./App.css";
import { useEffect } from "react";
import LogoBar from "./common-components/LogoBar";
import MenuNavBar from "./common-components/MenuNavBar";
import Footer from "./common-components/Footer";
import Home from "./pages/Home";
import HallOfFame from "./pages/HallOfFame";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  useHistory,
  Redirect,
} from "react-router-dom";
import SocialLearning from "./pages/SocialLearning";
import EmotionCaptures from "./pages/EmotionCaptures";
import FAQ from "./pages/FAQ";
import SapCourses from "./sap-components/sapCourses";
import LearningPath from "./sap-pages/learningPath";
import AwardsContent from "./sap-components/AwardsContent";
import SapNavBar from "./sap-components/sapNavBar";
import Testimonial from "./sap-pages/Testimonial";
import Certifications from "./sap-pages/certifications";
import Experts from "./sap-pages/experts";
import KeyStatistics from "./sap-pages/keyStatistics";
import { PageLayout } from "./PageLayout";
import { MsalProvider } from "@azure/msal-react";
import { CustomNavigationClient } from "./utils/NavigationClient";
import Feedback from "./sap-pages/Feedback";
import FeedbackData from "./sap-components/FeedbacksData";
import OracleRouting from "./oracle/OracleRouting";
import SapCalendar from "./sap-pages/SapCalendar";
import SalesforceRouting from "./salesforce/components/Routing";
import SpecialPrograms from "./sap-pages/SpecialPrograms";
import Dashboard from "./pages/Dashboard";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "./authConfig";
import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./authConfig";
import LearningDashboard from "./pages/LearningDashboard";
import CertificationDashboard from "./pages/CertificationDashboard";
import AdminPage from "./Admin/AdminPage";
import { useDispatch, useSelector } from "react-redux";
import { addUser, getUsers } from "./function-components/Redux/UsersSlice";
import AnalyticsPage from "./common-components/AnalyticsPage";

function App({ pca }) {
  const dispatch = useDispatch();
  // The next 3 lines are optional. This is how you configure MSAL to take advantage of the router's navigate functions when MSAL redirects between pages in your app
  const history = useHistory();
  const navigationClient = new CustomNavigationClient(history);

  pca.setNavigationClient(navigationClient);
  useEffect(() => {
    dispatch(getUsers());
  }, [dispatch]);
  return (
    <MsalProvider instance={pca}>
      <PageLayout>
        <div container justifyContent="center">
          <Pages />
        </div>
      </PageLayout>
    </MsalProvider>
  );
}
function Pages() {
  const { instance } = useMsal();
  const activeAccount = instance.getActiveAccount();
  let loggedInCareerLevel = "";
  let loggedInEnterpriseId = "";
  if (activeAccount) {
    loggedInCareerLevel = activeAccount.idTokenClaims.jobFamilyDescription;
    loggedInEnterpriseId = activeAccount.idTokenClaims.enterpriseID;
  }

  const allowedEnterpriseId = [
    "devika.gajanan.pote",
    "s.saraswathi",
    "praveen.rajaram",
    "ashfaque.mundewadi",
    "madhuri.gattu",
    "veena.bharadwaj",
    "srimoyee.b.das",
    "divya.p.sivakumar",
    "ankur.e.mishra",
    "sonali.ajit.adsule",
    "smita.chavan",
    "s.x.thakur",
    "a.kabra",
    "kondanna.nakanamoni",
    "varsha.a.tyagi",
    "prateek.a.mathur",
    "sudharshan.a.reddy",
    "tarun.motiwala",
    "smita.chavan",
    "aparna.gg",
    "amit.rambhia",
    "arpita.m.singh",
    "praharsha.singh",
    "shubham.khattri",
    "raja.chinthalapudi",
    "n.a.ashok.kulkarni",
    "sudheendra.n.teggi",
    "aruna.kumari",
    "rakesh.d.gowda",
    "nikhil.c.bajaj",
    "neha.m.mehta",
    "pranjal.rasane",
    "lopamudra.pattnaik",
    "n.kar.chaudhuri",
    "shameem.banu",
  ];
  const msalInstance = new PublicClientApplication(msalConfig);

  useEffect(() => {
    // console.log('0');
    if (activeAccount) {
      // console.log('1');
      fetchAccessToken();
      // console.log('2');
    }
  }, [activeAccount]);
  const fetchAccessToken = async () => {
    if (!activeAccount)
      throw Error(
        "No active account! Verify a user has been signed in and setActiveAccount has been called."
      );
    try {
      // console.log(activeAccount);
      const response = await msalInstance.acquireTokenSilent({
        ...loginRequest,
        account: activeAccount,
      });
      const bearer = `Bearer ${response.accessToken}`;
      // console.log(bearer);
      localStorage.setItem("token", bearer);
      // console.log("inside try block");
    } catch (error) {
      console.error("Error fetching access token:", error);
      localStorage.clear();
    }
  };
  return (
    <div>
      <div>
        <LogoBar />
        <Switch>
          <Route exact path="/">
            <MenuNavBar />
            <Home />
          </Route>
          <Route exact path="/home">
            <MenuNavBar />
            <Home />
          </Route>
          <Route exact path="/HallOfFame">
            <MenuNavBar />
            <HallOfFame />
          </Route>
          <Route exact path="/SocialLearning">
            <MenuNavBar />
            <SocialLearning />
          </Route>
          <Route exact path="/emotion">
            <MenuNavBar />
            <EmotionCaptures />
          </Route>
          <Route exact path="/faq">
            <MenuNavBar />
            <FAQ />
          </Route>
          <Route exact path="/userMaintenance">
            <MenuNavBar />
            <AdminPage />
          </Route>
          <Route exact path="/analytics">
            <MenuNavBar />
            <AnalyticsPage />
          </Route>
          <Route exact path="/dashboard">
            {(loggedInCareerLevel !== "" &&
              loggedInCareerLevel != 7 &&
              loggedInCareerLevel != 8 &&
              loggedInCareerLevel != 9 &&
              loggedInCareerLevel != 10 &&
              loggedInCareerLevel != 11 &&
              loggedInCareerLevel != 12) ||
              allowedEnterpriseId.includes(loggedInEnterpriseId) ? (
              <>
                <MenuNavBar />
                <Dashboard />
              </>
            ) : (
              <Redirect to="/home" />
            )}
          </Route>
          <Route exact path="/learningdashboard">
            {/* <MenuNavBar />
            <LearningDashboard/> */}
            <Redirect to="/home" />
          </Route>
          <Route exact path="/certificationdashboard">
            <MenuNavBar />
            <CertificationDashboard />
          </Route>
          <Route exact path="/SAPAcademy/Courses" component={SapCourses} />
          <Route exact path="/SAPAcademy/Course/:code" component={SapCourses} />
          <Route exact path="/SAPAcademy/LearningPaths">
            <SapNavBar />
            <LearningPath />
          </Route>
          <Route exact path="/SAPAcademy/specialPrograms">
            <SapNavBar />
            <SpecialPrograms />
          </Route>
          <Route exact path="/SAPAcademy/Testimonials">
            <SapNavBar />
            <Testimonial />
          </Route>
          <Route exact path="/certifications">
            <SapNavBar />
            <Certifications />
          </Route>
          <Route exact path="/SAPAcademy/Experts">
            <SapNavBar />
            <Experts />
          </Route>
          {/* <Route exact path="/SAPAcademy/KeyStatistics">
                <SapNavBar />
                <KeyStatistics />
            </Route>             */}
          {/* <Route exact path="/SAPAcademy/sap-calendar">              
                <SapNavBar />
                <SapCalendar/>                
            </Route> */}
          <Route exact path="/SAPAcademy/Awards">
            <SapNavBar />
            <AwardsContent />
          </Route>
          <Route exact path="/SAPAcademy/Feedback">
            <SapNavBar />
            <Feedback />
          </Route>
          <Route exact path="/SAPAcademy/Feedbacks">
            <SapNavBar />
            <FeedbackData />
          </Route>
        </Switch>
        <OracleRouting />
        <SalesforceRouting />
        <Footer />
      </div>
    </div>
  );
}

export default App;
